<template>
  <div class="card card-custom" v-if="userRight">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de modification d'un droit utilisateur</h2>
          <FormUserRight v-model="userRight" @submit="submit"></FormUserRight>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormUserRight from "@/components/admin/userRight/forms/formUserRight.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "editUserRight",
  components: {
    FormUserRight,
  },
  data: () => ({
    userRight: null,
    themes: [],
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes droits utilisateurs", route: "gestionClients" },
      { title: "Modifier un droit utilisateur" },
    ]);

    var userRightId = this.$route.params.id;
    var userRightData = this.$route.params.userRight;

    if (userRightData) {
      this.populateUserRightForm(userRightData);
    } else {
      Api.get(`/user_rights/${userRightId}`).then((userRight) => {
        this.populateUserRightForm(userRight.data);
      });
    }
  },
  methods: {
    submit: async function() {
      try {
        await Api.put(`user_rights/${this.userRight.id}`, {
          // TODO : Vérifier SI le theme n'existe pas deja dans la liste
          name: this.userRight.name,
          comment: this.userRight.comment,
          themes: this.userRight.themes.map(t => t['@id']),
        });
        Swal.fire({
          title: "",
          text: "Le droit utilisateur a été modifié.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({
          name: "gestionClients",
          query: {
            selected: "tab-userRights",
          },
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "",
          text:
            "Une erreur est survenue lors de la modification du droit utilisateur",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }
    },

    populateUserRightForm(userRight) {
      this.userRight = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines
        ...userRight,
      };
    },
  },
};
</script>
